/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.live.searchActorsTypeahead";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"q":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"limit":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.integer({"minimum":1,"maximum":100}), 10))});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"actors":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<Actor>((() => actor) as any), )});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Find actor suggestions for a prefix search term. Expected use is for auto-completion during text field entry. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output);

export { main };

export const $lxm = $nsid;

type Actor = { $type?: "place.stream.live.searchActorsTypeahead#actor";

  /**
   * The actor's DID
   */
  "did":l.DidString;

  /**
   * The actor's handle
   */
  "handle":l.HandleString };

export type { Actor };

const actor = /*#__PURE__*/ l.typedObject<Actor>($nsid, "actor", /*#__PURE__*/ l.object({"did":/*#__PURE__*/ l.string({"format":"did"}),"handle":/*#__PURE__*/ l.string({"format":"handle"})}));

export { actor };
